import { getResourcesDate } from '@utils/timeHelpers';

export const getDateDisplay = (dateObject) => (dateObject ? getResourcesDate(dateObject.at) : '-');
